import { isProduction } from './env';

export const drawerWidth = 280;
export const DEFAULT_COUNTRY_PHONE_CODE = '+51';
export const SMS_RESEND_TIMER = isProduction ? 60 : 4;
export const COMPANY_NAME = 'Préstamo 365';
// PHONES
export const CONTACT_CENTER_NUMBER = '016110744';
export const CALL_AUTH_NUMBER = '+51 162 691 88';
export const CONTACT_MAIL = 'ayuda@prestamo365.pe';
export const WHATSAPP_REGULAR = '932133534';
export const WHATSAPP_OVERDUE = '913638250';

//
export const ADDRESS = 'Río de la Plata 167, piso 7, San Isidro, Lima';
export const FACEBOOK = 'https://www.facebook.com/prestamo365.pe/';
export const LINKEDIN = 'http://linkedin.com/company/prestamo365';
export const COUNT_DAYS_SAVE_COOKIE = 30;
export const COOKIE_CONSENT_TTL_DAYS = 365;
export const COOKIE_CONSENT_VERSION = 1;
export const MIN_LOAN_REPAY_AMOUNT = '50';
export const MIN_LOAN_REPAY_REF_AMOUNT = '10';
export const MAX_API_CALL_TIME = 5;
export const TERMS_AND_CONDITIONS = '/terms-and-conditions/';
export const DATA_PRIVACY = '/privacypolicy/';
